import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ContractService } from '../../../services/contract.service';
import { ContractStep1Controller } from './contract-step1.controller';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.contract-step1', {
            url: '/contract-step1',
            ncyBreadcrumb: {
                label: 'Contratto',
                parent: 'registration.organization-data'
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Contratto'
            },
            resolve: {
                contractHtml: (ContractService: ContractService, $q, store: ng.a0.storage.IStoreService) => {
                    return ContractService.getContractHtml(store.get('registeringUser'))
                        .then((result) => {
                            return result;
                        }, (error) => {
                            return $q.reject(error);
                        });
                }
            },
            'views': {
                'multiContentRegistration': {
                    controller: ContractStep1Controller,
                    template: `
                        <section id="contract-step1" flex="100">
                            <div class="row margin-bottom-30">
                                <div class="col-xs-12">
                                    <h3>
                                        <span class="archismall-grey-header">Contratto Archi
                                            <span class="bold">SMALL</span>
                                        </span>
                                    </h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="panel panel-default" id="print-content">
                                    <div class="panel-heading">
                                        <h5 ng-bind-html="contractHtmlHeader"></h5>
                                    </div>
                                    <div class="panel-body scrollbar">
                                        <div ng-bind-html="contractHtmlBody" class="contract-html"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 centered" style="margin-bottom:16px">
                                <label class="css-input css-checkbox css-checkbox-rounded css-checkbox-default" for="confirmCheckbox">
                                  <input id="confirmCheckbox" name="confirmCheckbox" type="checkbox" ng-model="confirmCheckbox">
                                  <span></span><strong>Si dichiara e attesta, sotto la propria responsabilità, di aver preso visione di quanto sopra scritto e di averla accetta.</strong>
                                </label>
                              </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4 text-left">
                                    <a class="action" ng-click="prev()">
                                        <i class="fa fa-arrow-left"></i> Indietro </a>
                                </div>
                                <div class="col-xs-4 centered">
                                    <button class="btn orange-btn col-xs-12" ng-click="next()" ng-disabled="!confirmCheckbox || buttonDisabled">Approvo ed Accetto
                                        <i ng-if="buttonDisabled" class="fa fa-spinner fa-spin"></i>
                                    </button>
                                </div>
                                <div class="col-xs-2">
                                    <button ng-print print-element-id="print-content">
                                        <i class="fa fa-print fa-2x"></i>
                                    </button>
                                </div>
                            </div>
                        </section>
                    `
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ContractStep1Module: string = ng
    .module('contract-step1', [
        'ui.bootstrap',
        uiRouter
    ])
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/sections/registration/contract-step1/contract-step1.module.ts